module.exports = __webpack_public_path__ + "img/blueSapphireRings.784821c.png";